import { gsap } from "gsap";

document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".newfaq__accordion__item");
  if (items.length === 0) return;

  items[0].classList.add("active");

  items.forEach((item) => {
    const text = item.querySelector(".newfaq__accordion__item__text");
    const icon = item.querySelector(".icon svg");

    item.addEventListener("click", () => {
      items.forEach((el) => {
        if (el !== item) {
          gsap.to(el.querySelector(".newfaq__accordion__item__text"), {
            maxHeight: 0,
            duration: 0.1,
            ease: "power2.out",
          });
          gsap.to(el.querySelector(".icon svg"), {
            rotation: 0,
            duration: 0.3,
            ease: "power1.out",
          });
          el.classList.remove("active");
        }
      });

      if (item.classList.contains("active")) {
        gsap.to(text, {
          maxHeight: 0,
          duration: 0.5,
          ease: "power2.out",
          onComplete: () => {
            item.classList.remove("active");
          },
        });
        gsap.to(icon, {
          rotation: 0,
          duration: 0.3,
          ease: "power1.out",
        });
      } else {
        gsap.to(text, {
          maxHeight: 1000,
          duration: 0.5,
          ease: "power2.out",
        });
        item.classList.add("active");
        gsap.to(icon, {
          rotation: 45,
          duration: 0.3,
          ease: "power1.out",
        });
      }
    });
  });
});
